import api from '@/api/axios';

export async function createCompany(payload) {
  const response = await api.post('/add-my-company', payload);
  return response.data;
}
